import * as type from 'app/actionTypes/issue';

export function getIssues(filters = {}) {
  return {
    type: type.ISSUE_ABLE_DETAILS_REQUEST,
    payload: filters,
  }
}
